
const data = [
  {
    title: 'IT规划概述',
    description: '云恋科技遵循IT即业务的理念帮助企业进行IT规划和系统建设，帮助客户实现业务价值的提升。IT不能独立于业务，更不能独立于流程。'
  },
  {
    title: '服务内容',
    description: '互联网+转型规划服务\n' +
      '升级产业互联网规划服务\n' +
      '基础架构咨询服务\n' +
      '应用与基础软件管理服务\n' +
      '系统支援及终端设备服务'
  },
  {
    title: '服务特点',
    description: 'IT是投资行为，要规划业务价值并确保价值实现；\n' +
      'IT是战略部门，要有效推动战略落地；\n' +
      'IT建设为企业业务能力和恶竞争力提供独特贡献的核心力量。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/it-schema.js